import Seo from "../components/Seo";
import PageBanner from "../components/PageBanner";
import Reveal from "../components/Reveal";
import { CONTACT } from "../data/site";

const SECTIONS = [
  {
    h: "1. Introduction",
    p: [
      "CARDED (\"we\", \"our\", \"us\") is a Loan Direct Selling Agent (DSA) operating in India. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or submit an enquiry. By using our website or sharing your details, you consent to the practices described in this policy.",
    ],
  },
  {
    h: "2. Information We Collect",
    p: [
      "We may collect personal information that you voluntarily provide, including your full name, mobile number, email address, city, monthly income, loan requirement and any details you submit through our forms. We may also automatically collect technical data such as IP address, browser type, device information and usage data through cookies and similar technologies.",
    ],
  },
  {
    h: "3. How We Use Your Information",
    p: [
      "Your information is used to respond to your enquiries, assess suitable loan or credit card products, share your profile with partner Banks/NBFCs (with your consent), provide customer support, improve our services, comply with legal obligations and, where you have consented, send you marketing and promotional communications.",
    ],
  },
  {
    h: "4. Cookies",
    p: [
      "Our website may use cookies and similar tracking technologies to enhance user experience, analyse traffic and understand usage patterns. You can control or disable cookies through your browser settings, though some features of the website may not function optimally as a result.",
    ],
  },
  {
    h: "5. Data Security",
    p: [
      "We implement reasonable technical and organisational measures to protect your personal information against unauthorised access, alteration, disclosure or destruction. However, no method of transmission over the internet is completely secure, and we cannot guarantee absolute security.",
    ],
  },
  {
    h: "6. Sharing with Partner Banks / NBFCs",
    p: [
      "As a Loan DSA, our core function is to connect you with lenders. With your consent, we share the information you provide with relevant partner Banks and NBFCs so they can evaluate your eligibility. The decision to approve or reject any loan or credit card rests solely with these institutions.",
    ],
  },
  {
    h: "7. Third-Party Services",
    p: [
      "We may use third-party service providers for functions such as form handling, analytics and communication. These providers have access to your information only to perform tasks on our behalf and are obligated not to disclose or use it for other purposes.",
    ],
  },
  {
    h: "8. Marketing Communication Consent",
    p: [
      "Where you have opted in, we may contact you with promotional offers, service updates, reminders and notifications. You can withdraw this consent at any time by contacting us using the details provided below.",
    ],
  },
  {
    h: "9. WhatsApp Communication",
    p: [
      "If you have provided consent, we may communicate with you via WhatsApp for enquiry follow-ups, updates and promotional messages. You may opt out of WhatsApp communication at any time by informing us.",
    ],
  },
  {
    h: "10. RCS Communication",
    p: [
      "We may use Rich Communication Services (RCS) messaging to send you enhanced messages where supported by your device and network, subject to your consent. You can opt out at any time.",
    ],
  },
  {
    h: "11. SMS Communication",
    p: [
      "With your consent, we may send you SMS messages regarding your enquiry, service updates and promotional offers. Standard messaging rates may apply. You may opt out by contacting us.",
    ],
  },
  {
    h: "12. Call Consent",
    p: [
      "By submitting your contact details, you authorise CARDED and its representatives to contact you via phone calls regarding your enquiry and related offerings, even if your number is registered under DND/NDNC, to the extent permitted by applicable law and your consent.",
    ],
  },
  {
    h: "13. Email Communication",
    p: [
      "We may use your email address to respond to enquiries, share documentation requirements and, where consented, send promotional communications. Each marketing email will include an option to unsubscribe.",
    ],
  },
  {
    h: "14. User Rights",
    p: [
      "You have the right to access, correct or request deletion of your personal information, subject to applicable law. You may also object to or restrict certain processing and request a copy of the data we hold about you.",
    ],
  },
  {
    h: "15. Withdrawal of Consent",
    p: [
      "You may withdraw your consent for marketing communications or data sharing at any time by contacting us. Withdrawal will not affect the lawfulness of processing carried out before the withdrawal.",
    ],
  },
  {
    h: "16. Children's Privacy",
    p: [
      "Our services are intended for individuals who are 18 years of age or older. We do not knowingly collect personal information from minors. If we become aware that we have collected such information, we will take steps to delete it.",
    ],
  },
  {
    h: "17. Policy Updates",
    p: [
      "We may update this Privacy Policy from time to time. Changes will be posted on this page with a revised effective date. We encourage you to review this policy periodically.",
    ],
  },
  {
    h: "18. Contact Information",
    p: [
      `For any questions or requests regarding this Privacy Policy, please contact us at ${CONTACT.email} or call ${CONTACT.phone}. Office: ${CONTACT.address}.`,
    ],
  },
];

export default function Privacy() {
  return (
    <>
      <Seo
        title="Privacy Policy | CARDED"
        description="Read the CARDED Privacy Policy covering information we collect, how it is used, cookies, data security, sharing with partner Banks/NBFCs, communication consent and your rights."
      />
      <PageBanner overline="Legal" title="Privacy Policy" subtitle="Your privacy matters. This policy explains how CARDED collects, uses and protects your information." />

      <section className="bg-white pb-24 sm:pb-32" data-testid="privacy-content">
        <div className="mx-auto max-w-3xl space-y-10 px-6 sm:px-10">
          {SECTIONS.map((s) => (
            <Reveal key={s.h}>
              <div>
                <h2 className="text-xl font-semibold tracking-tight text-[#09090B] sm:text-2xl">{s.h}</h2>
                {s.p.map((para, i) => (
                  <p key={i} className="mt-3 text-sm leading-relaxed text-zinc-600 sm:text-base">{para}</p>
                ))}
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
